import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";
import styled from "styled-components";

interface CvvStyleProps {
    $isInvalid?: boolean;
    $isFullWidth?: boolean;
}

export const CvvContainer = styled.div<{ $isFullWidth?: boolean }>(({ $isFullWidth }) => ({
    width: $isFullWidth ? "100%" : "90px",
    marginRight: $isFullWidth ? "0" : "12px",
}));

export const CvvInput = styled.input<CvvStyleProps>(({ theme, $isInvalid, $isFullWidth }) => ({
    width: $isFullWidth ? "100%" : "70px",
    height: $isFullWidth ? "56px" : "44px",
    border: `1.5px solid ${
        $isInvalid ? theme.colors[theme.colorMode].negative : theme.colors[theme.colorMode].special_positive
    }`,
    background: theme.colors[theme.colorMode].background_Primary,
    outline: 0,
    margin: 0,
    padding: `${theme.spacing.empty} ${theme.spacing.medium}`,
    verticalAlign: "top",
    textAlign: "center",
    caretColor: theme.colors[theme.colorMode].special_positive,
    borderRadius: getCornerRadius(theme, "medium"),
    WebkitTextSecurity: "disc",
    MozTextSecurity: "disc",
    WebkitAppearance: "none",
}));
